<template>
  <qz-results-details
    :quote="quote"
    :is-view-monthly="isViewMonthly"
    :details-description="detailsDescription"
    :selected-optional-extras="selectedOptionalExtras"
    :is-details-drawer-open="isDetailsDrawerOpen"
    :filter-extras="filterExtras"
    :quote-position-number="quotePositionNumber"
    @re-quote="$emit('re-quote')"
    @go-to-form="$emit('go-to-form')"
    @close-drawer="$emit('close-drawer')"
    @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
  >
    <template #policy-excess>
      <!-- BUILDINGS EXCESS -->
      <div
        v-if="!isCoverContentsOnly"
        class="table"
      >
        <h4 class="mb-3 font-weight-bold">
          Excess &mdash; Buildings
        </h4>
        <v-simple-table
          dense
          class="theme--light light"
        >
          <template #default>
            <tbody>
              <tr>
                <th>Compulsory excess</th>
                <td class="text-right">
                  &pound;{{ formatExcess(quoteDetails.buildCompulsoryExcess) }}
                </td>
              </tr>
              <tr>
                <th>Voluntary excess</th>
                <td class="text-right">
                  &pound;{{ formatExcess(quoteDetails.buildVoluntaryExcess) }}
                </td>
              </tr>
              <tr>
                <th>Total excess</th>
                <td class="text-right">
                  &pound;{{ calcExcess(quoteDetails.buildCompulsoryExcess, quoteDetails.buildVoluntaryExcess) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <!-- CONTENTS EXCESS -->
      <div
        v-if="!isCoverBuildingsOnly"
        class="table"
      >
        <h4 class="mb-3 font-weight-bold">
          Excess &mdash; Contents
        </h4>
        <v-simple-table
          dense
          class="theme--light light"
        >
          <template #default>
            <tbody>
              <tr>
                <th>Compulsory excess</th>
                <td class="text-right">
                  &pound;{{ formatExcess(quoteDetails.contentsCompulsoryExcess) }}
                </td>
              </tr>
              <tr>
                <th>Voluntary excess</th>
                <td class="text-right">
                  &pound;{{ formatExcess(quoteDetails.contentsVoluntaryExcess) }}
                </td>
              </tr>
              <tr>
                <th>Total excess</th>
                <td class="text-right">
                  &pound;{{ calcExcess(quoteDetails.contentsCompulsoryExcess, quoteDetails.contentsVoluntaryExcess) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <p class="fs-12 mt-3">Please see provider’s website for any other excesses that may be applicable.</p>
    </template>
  </qz-results-details>
</template>

<script>
import QzResultsDetails from '@/components/QzResults/QzResultsDetails';
import { isEmpty } from 'lodash';

export default {
  name: 'results-details',
  components: {
    QzResultsDetails,
  },
  props: {
    quote: {
      required: false,
      type: Object,
      default: undefined,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isDetailsDrawerOpen: {
      type: Boolean,
      required: true,
    },
    isCoverContentsOnly: {
      type: Boolean,
      default: false,
    },
    isCoverBuildingsOnly: {
      type: Boolean,
      default: false,
    },
    quotePositionNumber: {
      required: true,
      type: Number,
    },
  },
  computed: {
    quoteDetails () {
      return this.quote?.details?.[0] || null;
    },
  },
  methods: {
    filterExtras (condition) {
      const accumulator = {};
      Object.keys(this.quoteDetails.optionalExtra).forEach((cover) => {
        const filteredByCoverType = (this.isCoverBuildingsOnly && cover === 'contents/damage') || (this.isCoverContentsOnly && cover === 'building/damage');

        if (this.quoteDetails?.optionalExtra[cover].included === condition && this.quoteDetails?.optionalExtra[cover].description !== 'DO_NOT_SHOW' && !filteredByCoverType) {
          accumulator[cover] = this.quoteDetails?.optionalExtra[cover];
        }
      });
      return isEmpty(accumulator) ? null : accumulator;
    },
    formatExcess (excess) {
      return parseFloat(excess).toFixed();
    },
    calcExcess (a, b) {
      return (parseFloat(a) + parseFloat(b)).toFixed();
    },
  },
};
</script>
